import React from "react";
import { Button as BSButton, Glyphicon } from "react-bootstrap";
import { v4 as uuid } from "uuid";
import { classNames } from "./utils/classNames";
import { useButtonClasses } from "./Button/Button.styles";
import { useUtilityStyles } from "./hooks/useUtilityStyles";
import { Tooltip } from "./Tooltip";
export const BUTTON_TYPE_STYLES = {
    primary: "primary",
    default: "default",
    suppressed: "link",
};
export const Button = ({ label, icon, disabled, disabledTooltipContent, onClick = () => { }, preventDefault = true, stopPropagation = true, type = "default", key = "", componentClass, ariaLabel, id, className, dataId, dataTestId, dataHook, block, styleOptions, "data-sentry-label": sentryLabel, }) => {
    const classes = useButtonClasses(type, block);
    const utilityStyles = useUtilityStyles(styleOptions);
    const handleClick = React.useCallback((e) => {
        if (preventDefault) {
            e.preventDefault();
        }
        if (stopPropagation) {
            e.stopPropagation();
        }
        if (onClick)
            onClick(e);
    }, [onClick, preventDefault, stopPropagation]);
    const button = (React.createElement(BSButton, { onClick: handleClick, disabled: disabled, bsStyle: BUTTON_TYPE_STYLES[type], key: key, componentClass: componentClass, "aria-label": ariaLabel, id: id, className: classNames(classes.button, className, utilityStyles.utilities), "data-id": dataId, "data-testid": dataTestId, "data-hook": dataHook, "data-sentry-label": sentryLabel },
        icon && React.createElement(Glyphicon, { glyph: icon }),
        (icon && ` ${label}`) || label));
    return !disabled || !disabledTooltipContent ? (button) : (React.createElement(Tooltip, { content: disabledTooltipContent, tooltipId: `button-${id || uuid()}-tooltip`, iconShown: false }, button));
};
